import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CvService {

  constructor(private http: HttpClient) { }

  uploadCV(formData: any) {
    console.log("Takutumira")
    return this.http.post(`${environment.apiUrl}/v1/uploads/cv`, formData);
  }
}
